var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as SDK from './lib/sdk';
var token = undefined;
function apiUrl() {
    if (DEVELOPMENT) {
        return "http://".concat(location.hostname, ":8585/api/").concat(STORE);
    }
    var host = 'https://tudoku-api.papergame.ru';
    if (location.search.includes('useTestApi')) {
        return "".concat(host, "/test-api/").concat(STORE);
    }
    return "".concat(host, "/api/").concat(STORE);
}
export var authApi = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getApiRequestWithAuth("/auth".concat(location.search)).then(function (res) {
                    if (document.cookie.indexOf('token=') === -1)
                        token = res.token;
                    return res;
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var yandexPurchase = function (signature) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, postApiRequest('/yandexPurchase', { signature: signature })];
}); }); };
export var getBalance = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, getApiRequest("/balance")
        // Платные функции (отмена ходи и т.д.)
    ];
}); }); };
// Платные функции (отмена ходи и т.д.)
export var payment = function (amount, overdraft) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, postApiRequest('/payment', { amount: amount, overdraft: overdraft })];
}); }); };
export var setScore = function (maxScore) {
    postApiRequest('/player/score', { maxScore: maxScore })
        .then(function () { })
        .catch(function (err) { return console.error(err); });
};
export var rewardedBonus = function (coins) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, getApiRequest("/bonus/rewarded?coins=".concat(coins))];
}); }); };
export var getDailyBonus = function (coins) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, timeout(getApiRequest("/bonus/daily?coins=".concat(coins, "&offset=").concat(new Date().getTimezoneOffset())), 500)];
    });
}); };
export var starBonus = function (coins) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, getApiRequest("/bonus/star?coins=".concat(coins))];
}); }); };
export var saveStateOnServer = function (data) {
    var state = Object.assign({}, data, { data: undefined, slices: undefined });
    postApiRequest('/state/save', { state: state })
        .then(function () { })
        .catch(function (err) { return console.error(err); });
};
export var getLeaderBoard = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, timeout(getApiRequest("/leader-board"), 1)];
    });
}); };
export var updateProfile = function (body) {
    postApiRequest('/player/info', body)
        .then(function () { })
        .catch(function (err) { return console.error(err); });
};
function timeout(promise, timeout) {
    if (timeout === void 0) { timeout = 500; }
    var start = Date.now();
    var callback = function (res, cb) {
        var time = Date.now() - start;
        if (time < timeout) {
            setTimeout(function () { return cb(res); }, timeout - time);
        }
        else {
            cb(res);
        }
    };
    return new Promise(function (resolve, reject) {
        promise.then(function (res) { return callback(res, resolve); }).catch(function (err) { return callback(err, reject); });
    });
}
export function postApiRequest(uri, body) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, apiRequest(uri, { method: 'POST', body: JSON.stringify(body) })];
        });
    });
}
function getApiRequest(uri) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, apiRequest(uri, { method: 'GET' })];
        });
    });
}
function getApiRequestWithAuth(_uri) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = apiRequest;
                    return [4 /*yield*/, uri(_uri)];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), { method: 'GET' }])];
            }
        });
    });
}
export function apiRequest(uri, init, noReply) {
    if (noReply === void 0) { noReply = false; }
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(FOR_VK || FOR_YANDEX)) return [3 /*break*/, 6];
                    if (token && uri.indexOf('token=') === -1) {
                        uri += "".concat(uri.indexOf('?') === -1 ? '?' : '&', "token=").concat(token);
                    }
                    return [4 /*yield*/, fetch("".concat(apiUrl()).concat(uri), __assign({ credentials: 'include', headers: {
                                'Content-Type': 'application/json; charset=UTF-8',
                                'x-requested-with': 'XMLHttpRequest',
                            } }, init))];
                case 1:
                    res = _a.sent();
                    if (!(res.status === 403 && uri.indexOf('/auth') !== 0 && noReply === false)) return [3 /*break*/, 3];
                    return [4 /*yield*/, authApi()];
                case 2:
                    _a.sent();
                    return [2 /*return*/, apiRequest(uri, init, true)];
                case 3:
                    if (!(res.status !== 200)) return [3 /*break*/, 5];
                    return [4 /*yield*/, res.json()];
                case 4: throw _a.sent();
                case 5: return [2 /*return*/, res.json()];
                case 6: return [2 /*return*/, Promise.resolve({})];
            }
        });
    });
}
function uri(uri) {
    return __awaiter(this, void 0, void 0, function () {
        var userId, params;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, SDK.Auth.getUid()];
                case 1:
                    userId = _a.sent();
                    params = "externalId=".concat(userId.externalId, "&encodedExternalId=").concat(encodeURIComponent(userId.externalId), "&provider=").concat(userId.provider, "&r=").concat(Math.random());
                    // TODO
                    // const params = new URLSearchParams()
                    // params.append('externalId', userId.externalId) // тут уже encodedExternalId/encodeURIComponent
                    // params.append('encodedExternalId', userId.externalId)
                    // params.append('provider', userId.provider)
                    // params.append('r', String(Math.random()))
                    return [2 /*return*/, "".concat(uri).concat(uri.indexOf('?') === -1 ? '?' : '&').concat(params)];
            }
        });
    });
}
